<template>
  <div class="card" id="post-category-select">
    <div class="card-body">
      <div class="divide-y">
        <div class="row">
          <template v-if="show">
            <span class="col-12">
              <UniversalSelect
                  v-model="fields.val"
                  :options="fields.items"
                  :mode="'single'"
                  :label="label"
                  @onChange="onChange"
              />
            </span>
            <div class="mt-2">
              <span class="col-12" v-if="showChild">
                <UniversalSelect
                    v-model="fields.valChild"
                    :options="fields.itemsChild"
                    :mode="'single'"
                    :label="labelChild"
                    @onChange="onChangeChild"
                />
              </span>
            </div>
          </template>
          <template v-else>
            <div class="mb-3">
              <div class="loader-item">
                <div class="spinner-border spinner-border-sm me-2"></div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import "./style.css"
import {ref, reactive, onMounted, defineOptions, watch} from "vue"
import UniversalSelect from "@/components/select_universal/Index"
import Api from "./Api"
import Image from "@/services/Image"

defineOptions({
  name: "WishlistCategory"
})

const props = defineProps({
  payload: {
    type: Object,
    default: () => ({}),
  },
  label: {
    type: String,
    default: "Категория"
  },
  labelChild: {
    type: String,
    default: "Вложенная категория"
  }
})

const emit = defineEmits(['onChange'])

const show = ref(false)
const showChild = ref(false)

const fields = reactive({
  val: null,
  valChild: null,
  items: [],
  itemsChild: [],
})

const formatElement = (item) => {
  let value = item["category_id"] ?? null
  let name = item["category_name"] ?? ""
  let hasImage = item["category_image_host"] && item["category_image_name"]
  let path = item["category_str_path"].replaceAll("###", "/")
  let level = item["category_level"]

  if (value === null || name === "") {
    return []
  }

  return [{
    value,
    name,
    image: hasImage ? Image.handle(item["category_image_host"], item["category_image_name"], 60, 60) : null,
    path,
    level,
  }]
}

async function getCategories(startId) {
  const items = await Api.categories(startId)

  return Object.values(items).flatMap(formatElement)
}

async function onChange(categoryId) {
  showChild.value = false
  fields.itemsChild = []
  fields.valChild = null

  if (categoryId === null || categoryId === undefined) {
    emit("onChange", null)
    return
  }

  const itemsChild = await getCategories(categoryId)
  if (itemsChild.length > 0) {
    fields.itemsChild = itemsChild
    showChild.value = true
  }

  // Отправляем ID главной категории, если подкатегории нет или она еще не выбрана
  emit("onChange", categoryId)
}

function onChangeChild(selectedChildCategory) {
  // Если выбрана подкатегория, отправляем именно её ID.
  // Если её сбросили — возвращаем ID главной категории (fields.val)
  const finalId = selectedChildCategory ?? fields.val
  emit("onChange", finalId)
}

onMounted(async () => {
  show.value = false
  fields.items = await getCategories()
  show.value = true
})

watch(() => props.payload, (newPayload) => {
  if (!newPayload) return
}, { deep: true })

// Флаг, который предотвратит повторное срабатывание логики загрузки
let isInitialized = false

watch(() => props.payload?.val, async (newVal) => {
  // Если значение пустое или компонент уже настроен — игнорируем изменения
  if (!newVal || isInitialized) return

  isInitialized = true // Блокируем этот watch навсегда для последующих изменений
  fields.val = newVal

  const itemsChild = await getCategories(newVal)
  if (itemsChild.length > 0) {
    fields.itemsChild = itemsChild
    showChild.value = true
  }
}, { immediate: true })
</script>
